import SettingRoutes from "./routes";
import './App.css'
import { useEffect } from "react";

function App() {
  useEffect(() => {
  import("./Pages/MapOverview/HighMap");
}, []);
  return (
    <>
      <SettingRoutes />
    </>
  );
}

export default App;
